/**
 * Sharp8 SDK singleton (used to be 'falcon-client' — now points at
 * the SHARP8 API, not Falcon directly. Per the independence model
 * (docs/architecture.md): the mini-app talks to Sharp8 only.
 *
 * Same-origin in production (Hono serves both SPA + API from the
 * same Railway `app` service), so baseUrl is just '/api/v1'.
 *
 * VITE_API_BASE_URL overrides for local dev / preview deploys.
 */

import { createFalconClient } from '@sharp8/falcon-client';

const apiBase = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';

// The underlying client treats `baseUrl` as the root for all paths.
// Our SDK adds '/v1/edges/today' etc. — but the SHARP8 API serves
// these as '/api/v1/edges/today'. So we set baseUrl to the part
// BEFORE '/v1' — i.e. '/api'. The SDK then issues '/api/v1/...' URLs.
const baseUrl = apiBase.replace(/\/v1\/?$/, '');

export const falcon = createFalconClient({
  baseUrl,
  token:    '', // Phase A: no auth. Phase B adds Telegram JWT.
  stubMode: false,
});
